import { PdOrderAgreement } from "./pd-order-agreement/PdOrderAgreement.js";
//#region src/pd-order-agreement/pd-order-agreement.ts
var tag = "pd-order-agreement";
if (!customElements.get(tag)) customElements.define(tag, PdOrderAgreement);
//#endregion
export { PdOrderAgreement };
